export default IconStackForward => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stack-forward" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 5l-8 4l8 4l8 -4l-8 -4" fill="currentColor" />
  <path d="M10 12l-6 3l8 4l8 -4l-6 -3" />
</svg>`;